import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Checkbox as MuiCheckbox } from '@mui/material';
import { withStyles } from '@mui/styles';
import { MAIN_THEME_COLOR } from '../../../const';

const styles = {
  root: {
    padding: 0,
    marginRight: 10,

    '&:hover': {
      color: MAIN_THEME_COLOR,
    },
    '&.no-padding': {
      marginRight: 0,
    },
  },
};

const CustomizedCheckbox = withStyles(styles)(MuiCheckbox);

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.08325 9.00004C1.08325 5.26809 1.08325 3.40211 2.24262 2.24274C3.40199 1.08337 5.26797 1.08337 8.99992 1.08337C12.7319 1.08337 14.5978 1.08337 15.7572 2.24274C16.9166 3.40211 16.9166 5.26809 16.9166 9.00004C16.9166 12.732 16.9166 14.598 15.7572 15.7573C14.5978 16.9167 12.7319 16.9167 8.99992 16.9167C5.26797 16.9167 3.40199 16.9167 2.24262 15.7573C1.08325 14.598 1.08325 12.732 1.08325 9.00004Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M5.6665 9.62508C5.6665 9.62508 6.99984 10.3855 7.6665 11.5001C7.6665 11.5001 9.6665 7.12508 12.3332 5.66675"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CrossIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.08325 9.00004C1.08325 5.26809 1.08325 3.40211 2.24262 2.24274C3.40199 1.08337 5.26797 1.08337 8.99992 1.08337C12.7319 1.08337 14.5978 1.08337 15.7572 2.24274C16.9166 3.40211 16.9166 5.26809 16.9166 9.00004C16.9166 12.732 16.9166 14.598 15.7572 15.7573C14.5978 16.9167 12.7319 16.9167 8.99992 16.9167C5.26797 16.9167 3.40199 16.9167 2.24262 15.7573C1.08325 14.598 1.08325 12.732 1.08325 9.00004Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M6 6L12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 6L6 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const EmptyIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.08325 9.00004C1.08325 5.26809 1.08325 3.40211 2.24262 2.24274C3.40199 1.08337 5.26797 1.08337 8.99992 1.08337C12.7319 1.08337 14.5978 1.08337 15.7572 2.24274C16.9166 3.40211 16.9166 5.26809 16.9166 9.00004C16.9166 12.732 16.9166 14.598 15.7572 15.7573C14.5978 16.9167 12.7319 16.9167 8.99992 16.9167C5.26797 16.9167 3.40199 16.9167 2.24262 15.7573C1.08325 14.598 1.08325 12.732 1.08325 9.00004Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const Checkbox = ({ className, noPadding, ...other }) => (
  <CustomizedCheckbox
    {...other}
    color="primary"
    icon={<EmptyIcon />}
    checkedIcon={<CheckIcon />}
    indeterminateIcon={<CrossIcon />}
    className={clsx(className, { 'no-padding': noPadding })}
  />
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  disabled: false,
};

export default Checkbox;
